import { render, staticRenderFns } from "./Red.vue?vue&type=template&id=6c34eb81&"
import script from "./Red.vue?vue&type=script&lang=js&"
export * from "./Red.vue?vue&type=script&lang=js&"
import style0 from "./Red.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports